// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader--q0K2P","dark":"loader_dark--Z4nt9"};